export const getItemInObjectByPath = (obj, path) => {
  if (!obj || !path) {
    return undefined;
  }

  // extract path by dot or [
  const pathParts = path.split(/[.\[\]]/).filter((part) => part !== '');

  return pathParts.reduce((current, key) => {
    if (current === null || current === undefined) {
      return undefined;
    }

    // Check if this is a numeric index for an array (or obj)
    const numericKey = parseInt(key, 10);
    if (!isNaN(numericKey)) {
      return current[numericKey];
    }

    return current[key];
  }, obj);
};

// builds a nested object from a "path" string
export const makeObjectFromPath = (path, value, target = {}) => {
  const parts = path.split('.');
  let current = target;

  for (let i = 0; i < parts.length; i++) {
    // Match "key" or "key[index]"
    const match = parts[i].match(/^(\w+)(\[(\d+)\])?$/);
    if (!match) {
      continue;
    }

    const key = match[1];
    const hasIndex = match[2] !== undefined;
    const index = hasIndex ? parseInt(match[3], 10) : null;

    if (i === parts.length - 1) {
      // Last segment → assign value
      if (hasIndex) {
        if (!Array.isArray(current[key])) {
          current[key] = [];
        }

        current[key][index] = value;
      } else {
        current[key] = value;
      }
    } else {
      // Intermediate segment → go deeper
      if (hasIndex) {
        if (!Array.isArray(current[key])) {
          current[key] = [];
        }

        if (!current[key][index]) {
          current[key][index] = {};
        }

        current = current[key][index];
      } else {
        if (!current[key]) {
          current[key] = {};
        }

        current = current[key];
      }
    }
  }

  return target;
};
